<template>
  <div id="checkout" class="checkout">
    <canvas3D v-if="hasPreview"/>
    <Configure3DModel v-if="currentOrderProcessStep === orderProcess.STEPS.CONFIGURE_MODEL"/>
    <div class="order-process__cart" v-if="currentOrderProcessStep === orderProcess.STEPS.VIEW_CART">
      <h2 class="title px-4 py-4 is-marginless is-4 has-text-grey">{{ $t('checkout.cart.label') }}</h2>
      <CartItemList :show-attachments="true" :cart-items="allCartItems"/>
      <div class="has-text-grey px-3 py-2"><span v-if="!isBusinessCustomer">{{ $t('checkout.cart.includingXPercentTaxes', {taxRate}) }}</span><span v-else>{{ $t('checkout.cart.plusXPercentTaxes', {taxRate}) }}</span></div>
      <div class="order-process__actions">
        <CreateNewPrintItemButton>
          <SvgIcon icon="icon--web-application_add" class="is-primary-dark"></SvgIcon>
          {{ $t('checkout.upload.addAnother3DFile') }}
        </CreateNewPrintItemButton>
        <RouterLink to="/payment-details" class="button is-primary-dark px-6">
          {{ $t('checkout.nextStep') }}
        </RouterLink>
      </div>
    </div>
  </div>
</template>

<script>
import Canvas3D from "./Canvas3D";
import Configure3DModel from "./Configure3DModel";
import CartItemList from "./CartItemList";
import {mapGetters} from "vuex";

import {orderProcess} from "../../store/constants/order-process";
import CreateNewPrintItemButton from "./CreateNewPrintItemButton";
import SvgIcon from "../svg/SvgIcon";

export default {
  name: "Checkout",
  data() {
    return {
      orderProcess
    };
  },
  props: {
    hasPreview: {
      type: Boolean,
      required: false,
      default: true,
    }
  },
  computed: {
    ...mapGetters(['allCartItems', 'current3DFile', 'currentOrderProcessStep', 'taxRate', 'isBusinessCustomer'])
  },
  watch: {
    currentOrderProcessStep() {
      window.scrollTo({top: 0, behavior: "smooth"});
    }
  },
  components: {SvgIcon, CreateNewPrintItemButton, CartItemList, Configure3DModel, Canvas3D}
}
</script>